'use client';

import {SignInForm} from "@/components/Auth/SignIn/SignIn.styled";
import {authApi} from "@/store/api/v1/auth";
import cookieManager from "@/managers/cookie.manager";
import {useRouter} from "@/helpers/navigation";
import useFormSuccessMutation from "@/hooks/useFormSuccessMutation";

const SignInFormAction = ({children, ...props}) => {
    const router = useRouter()

    useFormSuccessMutation([authApi, 'login'], (data) => {
        cookieManager.setItem('accessToken', data.token, data.expires)

        if (data.is_super_admin) {
            return router.push('/companies')
        }

        router.push('/')
    }, []);

    return (
        <SignInForm
            {...props}
            id={'login'}
            // scheme={signInScheme(te, tf)}
            endpoint={'login'}
            api={authApi}
        >
            {children}
        </SignInForm>
    )
}


export default SignInFormAction
